import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import './style.less';

export default class DatePickerLabels extends PureComponent {
    static propTypes = {
        checkIn: PropTypes.string,
        checkOut: PropTypes.string,
        arrivalLabel: PropTypes.string.isRequired,
        departureLabel: PropTypes.string.isRequired
    }

    static defaultProps = {
        arrivalLabel: 'Select your arrival date',
        departureLabel: 'Select your departure date'
    }

    render() {
        const {checkIn, checkOut, departureLabel, arrivalLabel} = this.props;
        return (
            <div className="date-picker-labels">
                {(!checkIn && !checkOut) && arrivalLabel}
                {(checkIn && !checkOut) && departureLabel}
            </div>
        );
    }
}
